import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { toast } from "sonner";
import "@/index.css";
import App from "@/App";

/** Jaring pengaman untuk panggilan API yang promise-nya tidak ditangani.
 *
 *  Puluhan halaman memakai pola `api.get(...).then(setState)` tanpa `.catch()`.
 *  Satu permintaan gagal — misalnya akun yang tidak terhubung ke data karyawan
 *  membuka Portal Karyawan — membuat promise-nya ditolak tanpa penangan, dan
 *  seluruh layar tertutup overlay "Uncaught runtime errors" sampai aplikasi
 *  tidak bisa dipakai sama sekali.
 *
 *  Di sini kegagalan diubah jadi notifikasi biasa: pengguna tetap tahu ada yang
 *  gagal, tapi halaman lain tetap jalan. Ini jaring pengaman, bukan pengganti
 *  penanganan error di masing-masing halaman.
 */
window.addEventListener("unhandledrejection", (event) => {
  const err = event.reason;
  const status = err?.response?.status;
  // 401 sudah ditangani interceptor (logout + redirect) — jangan ditimpa toast.
  if (!err?.isAxiosError || status === 401) return;
  event.preventDefault();
  const pesan = err?.response?.data?.detail
    || (status ? `Permintaan gagal (${status})` : "Tidak bisa terhubung ke server");
  toast.error(pesan);
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
